import { render, staticRenderFns } from "./DialogAddLectureTrackSubject.vue?vue&type=template&id=1cd4ac36"
import script from "./DialogAddLectureTrackSubject.vue?vue&type=script&lang=js"
export * from "./DialogAddLectureTrackSubject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd4ac36')) {
      api.createRecord('1cd4ac36', component.options)
    } else {
      api.reload('1cd4ac36', component.options)
    }
    module.hot.accept("./DialogAddLectureTrackSubject.vue?vue&type=template&id=1cd4ac36", function () {
      api.rerender('1cd4ac36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddLectureTrackSubject.vue"
export default component.exports